import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import { VNumberInput } from 'vuetify/labs/VNumberInput'

import '@mdi/font/css/materialdesignicons.css'

const vuetify = createVuetify({
  components: {
    ...components,
    VNumberInput
  },
  directives,

  display: {
    thresholds: {
      lg: 1270 /* Edge対策 */
    }
  },

  theme: {
    themes: {
      light: {
        colors: {
          header: '#33691E',
          background: '#F5F5F5' /* grey-lighten-4 */
        }
      }
    }
  },
  icons: {
    defaultSet: 'mdi'
  }
})

createApp(App).use(router).use(vuetify).mount('#app')
